// extracted by mini-css-extract-plugin
export var testimonial = "Testimonial-module--testimonial--hRqsK";
export var personPhotoAleksanderGorczyca = "Testimonial-module--personPhotoAleksanderGorczyca--xkU6P";
export var personPhotoBogdanTyskyy = "Testimonial-module--personPhotoBogdanTyskyy--W9XrY";
export var personPhotoLukaszChwistek = "Testimonial-module--personPhotoLukaszChwistek--1wVDo";
export var personPhotoAdamWrotkowski = "Testimonial-module--personPhotoAdamWrotkowski--e24xt";
export var personPhotoValerieKirk = "Testimonial-module--personPhotoValerieKirk--CaB1v";
export var quoteContainer = "Testimonial-module--quoteContainer--sJkvU";